<template>
  <v-container class="facility-reserve p-0" v-if="facilityType && settings" fluid>
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>
    <HkiaraceBannerFrame :src="'api/static/'+facilityType.banner"
                         :label="facilityType.name.toUpperCase()"
                         :is-snap-content="true"
                         :is-sticky="true"
    >
      <v-app-bar v-model="showFloatingInfo"
                 fixed
                 :class="['info-floating-header', {'d-none': !showFloatingInfo}]">
        <v-container>
          <v-row>
            <v-col class="text-left font-weight-bold">
              {{ facilityType.name }}
            </v-col>
          </v-row>
        </v-container>
      </v-app-bar>

      <v-app-bar v-model="showFloatingCategories"
                 fixed
                 :class="['category-floating-header', {'d-none': !showFloatingCategories}]"
                 :height="categoryHeight"
                 :style="floatCategoryStyle">
        <div class="overflow-x-auto scroll-wrapper">
          <div class="v-calendar v-calendar-daily v-calendar-category theme--light">
            <div class="v-calendar-daily__head">
              <div class="v-calendar-daily__intervals-head"></div>
              <div :class="['v-calendar-daily_head-day' , category.class]"
                   v-for="category in categories"
                   :key="category.day">
                <div class="v-calendar-daily_head-weekday">
                  {{ category.weekday }}
                </div>
                <div class="v-calendar-daily_head-day-label">
                  <button class="v-btn v-btn--depressed v-btn--fab v-btn--round theme--light v-size--default transparent">
                    <span class="v-btn__content">
                    {{ category.day }}
                  </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-app-bar>


      <v-row class="facility-reserve-content-row mb-3 py-3 title-font">
        <v-col>
          <datepicker v-model="selectedDate"
                      :format="calendarInputString"
                      :disabled-dates="calendarDisabled"
                      :highlighted="calendarHighlighted"
                      monday-first
                      :language="locale"
                      calendar-class="datepicker-calendar"
                      inline>
          </datepicker>
        </v-col>
      </v-row>

      <v-row class="facility-reserve-content-row mb-3 pt-9 title-font">
        <v-col class="availability-grid-col mx-0 mx-md-8 mx-lg-12 px-lg-12 px-md-8">
          <AvailabilityGrid :type-id="facilityType.id"
                            :from-date="selectedWeekStart.toISODate()"
                            :to-date="selectedWeekEnd.toISODate()"
                            :available-from="minDate"
                            :available-until="maxDate"
                            :max-daily-session="settings.booking_limit_day"
                            v-model="selectedTimeSlots"></AvailabilityGrid>
          <!--                    <AvailabilityGridOld :type-id="facilityType.id"-->
          <!--                                         :from-date="selectedWeekStart.toISODate()"-->
          <!--                                         :to-date="selectedWeekEnd.toISODate()"-->
          <!--                                         :available-from="minDate"-->
          <!--                                         :available-until="maxDate"-->
          <!--                                         :selected-time-slots="selectedTimeSlots"-->
          <!--                                         :max-session-length="settings.booking_limit_day"></AvailabilityGridOld>-->
        </v-col>
      </v-row>
      <v-row class="facility-reserve-steps py-2 px-2 py-md-6 px-md-6">
        <v-col cols="12" v-if="$vuetify.breakpoint.width > 600">
          <v-avatar color="primary" size="36">
            <span class="text-white">1</span>
          </v-avatar>
          <span>{{ $t('booking.step_1') }}</span>
          <v-icon>mdi-arrow-right</v-icon>
          <v-avatar color="grey" size="36">
            <span class="text-white">2</span>
          </v-avatar>
          <span class="text-muted">{{ $t('booking.step_2') }}</span>
          <v-icon>mdi-arrow-right</v-icon>
          <v-avatar color="grey" size="36">
            <span class="text-white">3</span>
          </v-avatar>
          <span class="text-muted">{{ $t('booking.step_3') }}</span>
        </v-col>
        <v-col cols="6" v-if="$vuetify.breakpoint.width <= 600" class="text-left font-size-25">
          <v-row>
            <v-col>
              <v-avatar color="primary" size="36">
                <span class="text-white">1</span>
              </v-avatar>
              <span>{{ $t('booking.step_1') }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-avatar color="grey" size="36">
                <span class="text-white">2</span>
              </v-avatar>
              <span class="text-muted">{{ $t('booking.step_2') }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-avatar color="grey" size="36">
                <span class="text-white">3</span>
              </v-avatar>
              <span class="text-muted">{{ $t('booking.step_3') }}</span>
            </v-col>
          </v-row>
        </v-col>

        <v-col :class="$vuetify.breakpoint.width <= 600?'text-right':'text-right'"
               :cols="$vuetify.breakpoint.width <= 484 ? 12 : $vuetify.breakpoint.width <= 600?6:12">
          <v-btn color="secondary" rounded
                 :large="$vuetify.breakpoint.width>600"
                 class="ml-2 my-2 quick-checkout-btn"
                 :disabled="!selectedTimeSlots.length"
                 @click="getOptions(true)"
                 v-if="!hasAdditionalItems">
            <v-img :src="require('../../../assets/quick_checkout.png')"
                   width="24px"
                   class="mr-2"></v-img>
            <span class="font-size-35">{{ $t('booking.quick_checkout') }}</span>
          </v-btn>
          <v-btn color="primary" rounded
                 :large="$vuetify.breakpoint.width>600"
                 class="ml-2 my-2"
                 :disabled="!selectedTimeSlots.length"
                 @click="getOptions(false)"
                 v-if="!hasAdditionalItems">
            <v-icon>mdi-arrow-right-circle-outline</v-icon>
            <span class="font-size-35">{{ $t('booking.add_to_cart') }}</span>
          </v-btn>

          <v-btn color="primary" rounded
                 :large="$vuetify.breakpoint.width>600"
                 class="ml-2 my-2"
                 :disabled="!selectedTimeSlots.length"
                 @click="showAdditionItems"
                 v-if="hasAdditionalItems">
            <v-icon>mdi-arrow-right-circle-outline</v-icon>
            <span class="font-size-35">{{ $t('booking.next_step') }}</span>
          </v-btn>
        </v-col>
      </v-row>

    </HkiaraceBannerFrame>

    <v-dialog v-model="additionalItemModalShown"
              content-class="additional-item-dialog"
              scrollable>
      <v-card>
        <v-card-title>
          <span class="flex-grow-1">{{ $t('booking.select_additional_items') }}</span>
          <v-btn icon
                 class="additional-item-dialog-close-btn"
                 x-large
                 plain
                 :ripple="false"
                 @click="additionalItemModalShown = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-container fluid class="pa-0 overflow-y-scroll">
            <v-form ref="additionalItemForm">
              <div v-for="(item, index) in additionalItems"
                   :class="['additional-item', {'mobile': $vuetify.breakpoint.smAndDown}]"
                   :key="item.id">
                <div class="additional-item-label">
                  <v-img :src="'api/static/' + item.icon"
                         contain
                         max-width="100px"
                         max-height="100px"></v-img>
                  <span class="flex-grow-1 text-left">
                    <b>{{ item.name }}</b>
                  </span>
                </div>
                <div class="addition-item-input-div">
                  <span class="additional-item-price">${{ item.price }}</span>
                  <v-text-field type="number"
                                v-model="selectedAdditionalItems[item.id]"
                                hide-details
                                min="0"
                                :max="item.max_per_booking"
                                class="additional-item-input"
                                dense
                                solo
                                autocomplete="off">
                    <template #prepend>
                      <v-btn icon
                             x-small
                             :disabled="selectedAdditionalItems[item.id] === 0"
                             @click="minusAdditionalItem(item)">
                        <v-icon x-small>fas fa-minus</v-icon>
                      </v-btn>
                    </template>
                    <template #append v-if="item.max_per_booking !== -1">
                      <span class="small">/ {{ item.max_per_booking }}</span>
                    </template>
                    <template #append-outer>
                      <v-btn icon
                             x-small
                             :disabled="selectedAdditionalItems[item.id] >= item.max_per_booking"
                             @click="addAdditionalItem(item)">
                        <v-icon x-small>fas fa-plus</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                  <span class="additional-item-price"><b>${{ item.price * selectedAdditionalItems[item.id] }}</b></span>
                </div>
              </div>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
          <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
          <v-btn color="secondary" rounded
                 class="my-2 quick-checkout-btn"
                 @click="getOptions(true)">
            <span class="font-size-35">{{ $t('booking.quick_checkout') }}</span>
          </v-btn>
          <v-btn color="primary" rounded
                 class="ml-4 my-2"
                 @click="getOptions(false)">
            <span class="font-size-35">{{ $t('booking.add_to_cart') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="choiceSelectorShown" content-class="facility-dialog" persistent scrollable>
      <v-card>
        <v-card-title>{{ $t('booking.select_venue') }}</v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-form ref="choiceSelectorForm">
              <v-row v-for="type_session in availableOptions"
                     :key="type_session.type_session.id">
                <v-col cols="12"
                       class="text-bold text-left">
                  {{ $t('booking.time') }} {{ getTypeSessionLabel(type_session.type_session) }}
                </v-col>
                <v-col cols="12">
                  <v-radio-group :rules="requiredRules"
                                 v-model="selectedChoice[type_session.type_session.id]">
                    <v-radio v-for="option in sortedOptions(type_session.options)"
                             :key="option.id"
                             :label="option.item.name"
                             :value="option"
                             @change="choiceSelected(type_session.type_session.id, option)">
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>


        <!--        <v-container class="grey lighten-5">-->
        <!--          <v-row no-gutters-->
        <!--                 v-for="type_session in availableOptions"-->
        <!--                 :key="type_session.type_session.id">-->
        <!--            <v-col>-->
        <!--              <v-card-title>{{ $t('booking.select_venue') }}</v-card-title>-->
        <!--              <div class="text-bold text-left" style="padding-left: 16px; padding-right: 16px;">{{ $t('booking.time') }} {{ getTypeSessionLabel(type_session.type_session) }}</div>-->
        <!--              <v-card-text>-->
        <!--                <v-radio-group>-->
        <!--                  <v-radio v-for="option in sortedOptions(type_session.options)"-->
        <!--                           :key="option.id"-->
        <!--                           :label="option.item.name"-->
        <!--                           @change="choiceSelected(type_session.type_session.id, option)">-->
        <!--                  </v-radio>-->
        <!--                </v-radio-group>-->
        <!--              </v-card-text>-->
        <!--            </v-col>-->
        <!--          </v-row>-->
        <!--        </v-container>-->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text
                 @click="choiceSelectorShown = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn text
                 color="rgb(142, 118, 91)"
                 @click="$refs.choiceSelectorForm.validate() && reservePartials()">
            {{ $t('next') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {en, zh} from 'vuejs-datepicker/dist/locale'
import AvailabilityGrid from "../../../components/acc_booking/AvailabilityGrid";
import {DateTime} from 'luxon';
import $ from 'jquery'
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import {computed, onBeforeUnmount, onMounted, ref} from '@vue/composition-api';
import _ from 'lodash';

export default {
  name: 'FacilityReserve',
  components: {HkiaraceBannerFrame, AvailabilityGrid, Datepicker},
  setup(props, {root}) {
    const settings = ref(null);
    const maxDate = computed(() => {
      if (settings.value) {
        return DateTime.local().plus({days: settings.value.in_advance_booking_period}).toISO();
      }
      return null;
    })
    const getSettings = function () {
      root.$callAPI('room/settings/', {}, function (response) {
        settings.value = response.body.settings;
      })
    };
    const locale = computed(() => {
      return root.$i18n.locale === 'en' ? en : zh;
    });

    const facilityTypeId = ref(root.$route.params.itemTypeId);
    const facilityType = ref(null);
    const getFacilityType = function () {
      root.$callAPI('aafb/facility_types/', {type_id: facilityTypeId.value}, function (response) {
        facilityType.value = response.body.item_type;
      });
    };

    // Datepicker
    const selectedDate = ref(new Date());
    const calendarInputString = computed(() => {
      return selectedWeekStart.value.toISODate() + ' - ' + selectedWeekEnd.value.toISODate();
    });
    const calendarDisabled = computed(() => {
      return {
        to: DateTime.local().minus({days: 1}).toJSDate(),
        from: DateTime.local().startOf('day').plus({days: settings.value.in_advance_booking_period}).toJSDate(),
      }
    });
    const calendarHighlighted = computed(() => {
      return {
        from: selectedWeekStart.value,
        to: selectedWeekEnd.value,
      };
    });

    //
    const selectedTimeSlots = ref([]);
    const selectedWeekStart = computed(() => {
      if (root.$vuetify.breakpoint.width <= 0) {
        return DateTime.fromJSDate(selectedDate.value);
      }
      return DateTime.fromJSDate(selectedDate.value).startOf('week');
    });
    const selectedWeekEnd = computed(() => {
      if (root.$vuetify.breakpoint.width <= 0) {
        return DateTime.fromJSDate(selectedDate.value);
      }
      return DateTime.fromJSDate(selectedDate.value).endOf('week');
    });

    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const selectedSessions = ref([]);

    const hasAdditionalItems = computed(() => {
      if (facilityType.value) {
        return facilityType.value.additional_items.length > 0;
      }

      return false;
    })
    const additionalItems = computed(() => {
      if (facilityType.value) {
        return facilityType.value.additional_items;
      }

      return [];
    });
    const selectedAdditionalItems = ref({});
    const minusAdditionalItem = function (item) {
      selectedAdditionalItems.value[item.id] = Math.max(selectedAdditionalItems.value[item.id] - 1, 0);
    }
    const addAdditionalItem = function (item) {
      selectedAdditionalItems.value[item.id] = Math.min(selectedAdditionalItems.value[item.id] + 1, item.max_per_booking);
    }
    const additionalItemModalShown = ref(false);
    const showAdditionItems = function () {
      let d = {};
      additionalItems.value.forEach((item) => {
        d[item.id] = 0;
      })
      selectedAdditionalItems.value = d;

      additionalItems.value = [];
      additionalItemModalShown.value = true;
    }

    const availableOptions = ref(null);
    const sortedOptions = function (options) {
      return _.clone(options).sort((a, b) => a.item.name < b.item.name ? -1 : 1)
    }
    const choiceSelectorShown = ref(false);
    const getTypeSessionLabel = function (type_session) {
      let start = DateTime.fromISO(type_session.start);
      let end = DateTime.fromISO(type_session.end);

      return `${start.toFormat('yyyy-MM-dd HH:mm')} - ${end.toFormat('HH:mm')}`;
    };
    const isQuickCheckout = ref(false);
    const selectedChoice = ref({});
    const choiceSelected = function (type_session_id, item_session) {
      selectedChoice.value[type_session_id] = item_session;
    };
    const reservePartials = function () {
      selectedSessions.value = Object.values(selectedChoice.value);
      reserveSessions();
    };
    const getOptions = function (quickCheckout) {
      selectedSessions.value = [];
      selectedChoice.value = {};
      isQuickCheckout.value = quickCheckout;
      root.$callAPI('room/search/type_options/', {
        type_session_ids: selectedTimeSlots.value.map((s) => {
          return s.id;
        }),
      }, function (response) {
        if (response.body.all_available) {
          let all_available = response.body.all_available
          selectedSessions.value = all_available[Object.keys(all_available)[0]];
          reserveSessions();
        } else {
          let options = response.body.partials;
          let allSingleOption = true

          options.forEach((type_session) => {
            if (type_session.options.length === 1) {
              choiceSelected(type_session.type_session.id, type_session.options[0])
            } else {
              allSingleOption = false
            }
          })

          if (allSingleOption) {
            reservePartials();
          } else {
            availableOptions.value = options;
            choiceSelectorShown.value = true;
          }
          // selectedSessions.value = response.body.partials;
          // reserveSessions();
        }
      }, function (response) {
        if (response.status === 401) {
          root.$router.push({name: 'login', query: {after: root.$route.path}});
        } else if (response.body.msg === 'error_messages.id_not_validated') {
          root.$showAlertMessage(root.$t('error_messages.id_not_validated'), () => {
            root.$router.push({name: 'sasv-verify'});
          });
        } else if (response.body.msg === 'error_messages.acc_not_activated') {
          root.$showAlertMessage(root.$t('error_messages.acc_not_activated'), () => {
            root.$router.push({name: 'my-account'});
          });
        } else if (response.body.msg === 'error_messages.account_suspended') {
          root.$showAlertMessage(this.$t('error_messages.account_suspended'));
        } else {
          root.$showAlertMessage();
        }
      });
    };
    const reserveSessions = function () {
      let selectedSessionIds = selectedSessions.value.map((s) => {
        return s.id;
      });
      // root.$callAPI('aafb/create_booking/', {
      root.$callAPI('aafb/add_booking/', {
        session_ids: selectedSessionIds,
        additional_items: selectedAdditionalItems.value,
      }, function (response) {
        root.$storeDispatch('getShoppingCart');
        if (isQuickCheckout.value) {
          root.$router.push({name: 'booking-preview', params: {bookingRecordId: response.body.booking_record_id}});
        } else {
          root.$router.push({name: 'shopping-cart'});
        }
      }, function (response) {
        if (response.status === 401) {
          root.$router.push({name: 'login', query: {after: root.$route.path}});
        } else if (response.body.msg === 'error_messages.id_not_validated') {
          root.$showAlertMessage(root.$t('error_messages.id_not_validated'), () => {
            root.$router.push({name: 'sasv-verify'});
          });
        } else if (response.body.msg === 'error_messages.acc_not_activated') {
          root.$showAlertMessage(root.$t('error_messages.acc_not_activated'), () => {
            root.$router.push({name: 'my-account'});
          });
        } else if (response.body.msg === 'error_messages.account_suspended') {
          root.$showAlertMessage(this.$t('error_messages.account_suspended'));
        } else {
          if ('msg' in response.body) {
            let msg = response.body.msg;

            if (root.$te('error_messages.' + msg)) {
              root.$showAlertMessage(root.$t('error_messages.' + msg));
            } else {
              root.$showAlertMessage(msg);
            }
          }
        }
      })
    };

    const showFloatingInfo = ref(false);
    const showFloatingCategories = ref(false);
    const categories = computed(() => {
      let today = DateTime.fromJSDate(new Date());

      let c = [];

      let d = selectedWeekStart.value;

      while (d.startOf('day') < selectedWeekEnd.value.endOf('day')) {
        let cls = '';

        if (today.hasSame(d, 'day')) {
          cls = 'v-present';
        } else {
          cls = d < today ? 'v-past' : 'v-future';
        }


        c.push({
          day: d.toFormat('d'),
          weekday: d.toFormat('ccc'),
          class: cls,
        });

        d = d.plus({day: 1});
      }

      return c;
    })
    const categoryHeaderX = ref(0);
    const categoryHeaderWidth = ref(0);
    const categoryHeight = ref(48);
    const floatCategoryStyle = computed(() => {
      return {
        left: `${categoryHeaderX.value + 1}px`,
        width: `${categoryHeaderWidth.value - 1}px`,
        top: `${(root.$vuetify.breakpoint.smAndDown ? 150 : 158)}px !important`,
      }
    })

    function onScroll(e) {
      let banner = $('.hkiarace-banner-frame-banner')[0];
      let bannerRect = banner.getBoundingClientRect();
      showFloatingInfo.value = bannerRect.bottom <= 160;


      let header = $('.availability-grid .v-calendar-daily__head')[0];
      if (header) {
        let availabilityGrid = $('.availability-grid')[0];

        let rect = header.getBoundingClientRect();
        showFloatingCategories.value = rect.top <= 150 && availabilityGrid.getBoundingClientRect().bottom >= 250;
        categoryHeight.value = rect.height;
        categoryHeaderX.value = rect.x;
        categoryHeaderWidth.value = rect.width;
      }
    }

    onMounted(() => {
      getSettings();
      getFacilityType();
      window.addEventListener('scroll', onScroll);
      window.addEventListener('resize', onScroll);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    })

    return {
      facilityType,
      settings,
      maxDate,

      selectedDate,
      calendarInputString,
      calendarDisabled,
      calendarHighlighted,
      locale,

      selectedTimeSlots,
      selectedWeekStart,
      selectedWeekEnd,

      requiredRules,
      selectedSessions,

      hasAdditionalItems,
      additionalItems,
      selectedAdditionalItems,
      minusAdditionalItem,
      addAdditionalItem,
      additionalItemModalShown,
      showAdditionItems,

      availableOptions,
      sortedOptions,
      selectedChoice,
      choiceSelectorShown,
      getTypeSessionLabel,
      choiceSelected,
      reservePartials,

      getOptions,
      reserveSessions,

      minDate: DateTime.local().toISO(),

      showFloatingInfo,

      showFloatingCategories,
      categories,
      categoryHeight,
      floatCategoryStyle,
    }
  },
}
</script>

<style lang="less">
.facility-dialog {
  width: auto;
  min-width: 40vw;
  max-width: 80vw;
}

.additional-item-dialog {
  width: auto;
  min-width: 40vw;
  max-width: 80vw;

  .additional-item-dialog-close-btn {
    position: absolute;
    right: 0;
    top: 0;
  }

  .additional-item {
    width: 100%;
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    padding-bottom: 16px;

    &.mobile {
      flex-direction: column;
      align-items: stretch;
    }

    .additional-item-label {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      width: 300px;
      padding: 8px;

      .v-image {
        margin: 0 !important;
      }
    }

    .addition-item-input-div {
      flex: 1 1 auto;
      display: flex;
      align-items: center;
      padding: 0 8px;
      min-width: 200px;

      .additional-item-price {
        flex: 1 1 0;
        min-width: 48px;
      }

      .additional-item-input {
        margin-left: 24px !important;
        margin-right: 24px !important;

        input {
          text-align: center;
        }

        /* Chrome, Safari, Edge, Opera */

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */

        input[type=number] {
          -moz-appearance: textfield;
        }
      }
    }
  }
}

.facility-reserve {

  .datepicker-calendar {
    width: 100%;
    border: none;
    margin: auto;

    .selected {
      background: #cae5ed !important;
    }
  }

  .facility-reserve-content-row {
    background-color: white;

    text-transform: uppercase;

    .availability-grid-col {
      /*overflow: scroll;*/
      /*max-width: 750px;*/
      margin: auto;

      .availability-grid-legend {

      }
    }
  }

  .facility-reserve-steps {
    .v-avatar {
      margin-right: 12px;
    }

    .mdi-arrow-right {
      margin-left: 24px;
      margin-right: 12px;
    }
  }
}

.quick-checkout-btn {
  color: black !important;
}


#choiceSelector {
  .custom-radio {
    margin-bottom: 30px;
  }
}

.info-floating-header {
  top: 94px !important;
  z-index: 4 !important;
  background-color: white !important;
}

.category-floating-header {
  font-family: 'Montserrat', Roboto, "PingFang TC", "Heiti TC", "\5FAE\8EDF\6B63\9ED1\9AD4", "Microsoft JhengHei", "sans-serif" !important;
  background-color: transparent !important;
  box-shadow: none !important;
  transition: none;
  z-index: 4 !important;

  .scroll-wrapper {
    width: 100%;
  }

  .v-toolbar__content {
    background-color: transparent;
    padding: 0;
  }

  .v-calendar {
    border-left: none !important;
  }

  .v-calendar-daily__head {
    margin-right: 0;
    border-left: none !important;

    .v-calendar-daily__intervals-head {
      width: 45px;
      border-left: none !important;
    }
  }

  .v-calendar-daily_head-day:last-child {
    border-right: none !important;
  }

  .v-calendar-daily__intervals-body {
    border-right: none !important;
  }

  .v-calendar-daily__day {
    border-right: none !important;
    border-bottom: none !important;

    &:last-child {
      border-right: none !important;
    }
  }

  .v-btn--fab.v-size--default {
    height: initial;
    width: initial;
  }
}
</style>
